module.exports = __WEBPACK_EXTERNAL_MODULE_27__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 27
// module chunks = 0 1